module.exports = __webpack_public_path__ + "images/c7bd13cd4ea44faea3eaa06122d373e0-Canlink logo.png";